import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Navigation, PaymentCardOptions } from '@quizzach/components';
import { Reveal } from '@quizzach/motion';
import { LegalHead, LegalPage, PaymentSecurityArticle } from '@quizzach/styles';
import { scrollToTop } from '@quizzach/utils';

export const PaymentProviderSecurity = () => {
	const { t } = useTranslation();

	useEffect(() => {
		scrollToTop();
	}, []);

	return (
		<LegalPage>
			<Navigation />

			<LegalHead>
				<Reveal as='h1'>{t('footer.paymentSecurity.title')}</Reveal>
			</LegalHead>

			<PaymentSecurityArticle data-id='payment-provider-security-container'>
				<Reveal className='col'>
					<p>{t('footer.paymentSecurity.p1')}</p>
					<p>{t('footer.paymentSecurity.p2')}</p>
					<p>{t('footer.paymentSecurity.p3')}</p>
					<p>{t('footer.paymentSecurity.p4')}</p>
					<p>{t('footer.paymentSecurity.thanks')}</p>
				</Reveal>
				<div className='cards'>
					<PaymentCardOptions />
				</div>
			</PaymentSecurityArticle>
		</LegalPage>
	);
};
